import { render, staticRenderFns } from "./customPage.vue?vue&type=template&id=7c09bfb0&"
import script from "./customPage.vue?vue&type=script&lang=js&"
export * from "./customPage.vue?vue&type=script&lang=js&"
import style0 from "./customPage.vue?vue&type=style&index=0&id=7c09bfb0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c09bfb0')) {
      api.createRecord('7c09bfb0', component.options)
    } else {
      api.reload('7c09bfb0', component.options)
    }
    module.hot.accept("./customPage.vue?vue&type=template&id=7c09bfb0&", function () {
      api.rerender('7c09bfb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customPage.vue"
export default component.exports